<div class="row mt-2">
    <div class="col-md-8">
      <div class="card">
          <div class="card-header">
              <div class="card-title mb-0"><strong>Page</strong></div>
          </div>
          <div class="card-body">
              <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="color" class="form-label">Color <em>*</em></label>
                            <input type="text" class="form-control" id="color" name="color" #color="ngModel" [(ngModel)]="data.color" required>
                            <div *ngIf="f.submitted && color.invalid" class="invalid-feedback">
                                <div *ngIf="color.errors.required">Color is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="label" class="form-label">Label <em>*</em></label>
                            <input type="text" class="form-control" id="label" name="label" #label="ngModel" [(ngModel)]="data.label" required>
                            <div *ngIf="f.submitted && label.invalid" class="invalid-feedback">
                                <div *ngIf="label.errors.required">Label is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="value" class="form-label">Winning Value <em>*</em></label>
                            <input type="text" class="form-control" id="value" name="value" #value="ngModel" [(ngModel)]="data.value" required>
                            <div *ngIf="f.submitted && value.invalid" class="invalid-feedback">
                                <div *ngIf="value.errors.required">Value is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="sort" class="form-label">Sort <em>*</em></label>
                            <select class="form-control" id="sort" name="sort" #sort="ngModel" [(ngModel)]="data.sort" required>
                                <option [value]="'1'">1</option>
                                <option [value]="'2'">2</option>
                                <option [value]="'3'">3</option>
                                <option [value]="'4'">4</option>
                                <option [value]="'5'">5</option>
                                <option [value]="'6'">6</option>
                                <option [value]="'7'">7</option>
                                <option [value]="'8'">8</option>
                                <option [value]="'9'">9</option>
                                <option [value]="'10'">10</option>
                                <option [value]="'11'">11</option>
                                <option [value]="'12'">12</option>
                                <option [value]="'13'">13</option>
                                <option [value]="'14'">14</option>
                                <option [value]="'15'">15</option>
                            </select>
                            <div *ngIf="f.submitted && sort.invalid" class="invalid-feedback">
                                <div *ngIf="sort.errors.required">Sorting is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                  <div class="row">
                      <div class="col-12">
                          <div class="mb-3">
                              <label for="status" class="form-label">Status <em>*</em></label>
                              <select class="form-control" id="status" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                                  <option [value]="1">Active</option>
                                  <option [value]="0">Disabled</option>
                              </select>
                              <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                                  <div *ngIf="status.errors.required">Status is required</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <button type="submit" class="btn btn-primary">Update</button>
              </form>
          </div>
      </div>
    </div>
  </div>